import React from 'react';
import {File as FWFile} from 'FW/Models/File';
import Player from 'Components/Video/Player';
import VimeoVideo from 'Components/Video/VimeoVideo';
import YouTubeVideo from 'Components/Video/YouTubeVideo';
import RumbleVideo from 'Components/Video/RumbleVideo';
import {LiveStreamChannel} from '../../../FW/Models/LiveStreamChannel';
import Loading from '../../../CommonElements/Loading';

class Video extends React.Component {
  constructor(props) {
    super(...arguments);
    this.state = this.processPropsAndGetState(props);
    let details = props.section.prop('file_details');
    if (details.type === 'live') {
      this.channel = LiveStreamChannel.findOrCreate({id: details.id});
    }
  }

  shouldComponentUpdate(props, newState) {
    let {src} = this.processPropsAndGetState(props);
    return (
      this.state.src !== src ||
      this.state.channelLoaded !== newState.channelLoaded ||
      this.state.loaded !== newState.loaded
    );
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    this.setState(this.processPropsAndGetState(newProps));
  }

  processPropsAndGetState(props, prevState) {
    let details = props.section.prop('file_details');
    let state;
    if (details.type === 'local' && details.id) {
      let file = FWFile.findOrCreate({id: details.id});
      state = {
        file: file,
        src: details.type === 'local' ? (details.use_background_version ? file.backgroundUrl : file.helper.webUrl) : details.src
      };
      if (!props.section.prop('auto_play')) {
        state.thumbnailSrc = file.helper.thumbnailUrl();
      }
    } else if (details.type === 'live') {
      state = {
        src: [],
        loaded: true
      };
    } else {
      state = {
        src: details.src
      };
    }
    state.aspect_ratio = details.aspect_ratio;

    return state;
  }

  openPublisher() {
    this.channel.openPublisher();
  }

  hideLoad = () => {
    this.setState({
      loaded: true
    });
  }

  render() {
    let details = this.props.section.prop('file_details');
    let autoplay = !FW.inEditor() ? this.props.section.prop('auto_play') : false;
    let player;

    if (
      details.type === 'vimeo' ||
      (details.type === 'local' &&
        this.state.file &&
        this.state.file.get('location') === 'vimeo')
    ) {
      let file = this.state.file ? this.state.file : null;
      player = <VimeoVideo src={this.state.src} file={file} autoplay={autoplay} details={this.props.section.prop('file_details')} />;
    } else if (
      details.type === 'youtube' ||
      (details.type === 'local' &&
        this.state.file &&
        this.state.file.get('location') === 'youtube')
    ) {
      player = <YouTubeVideo src={this.state.src} autoplay={autoplay} details={details} />;
    } else if (details.type === 'live') {
      if (this.channel && this.channel.get('id')) {
        const viewerId = FW.store.get('section-' + this.props.section.get('id') + '-viewer_id');
        player = (
          <Player scrollPlay={this.props.section.prop('scroll_play')} aspectRatio={this.state.aspect_ratio} sources={this.channel.liveWowzaSources} viewerId={viewerId} channel={this.channel} liveStream={true} autoplay={autoplay} />
        );
      } else {
        player = (
          <div
            style={{
              textAlign: 'center',
              marginTop: this.props.section.prop('height') / 2
            }}
          >
            <p className="lead">
              No channel selected for this video section. Please edit the
              section and select a channel.
            </p>
          </div>
        );
      }
    } else if (details.type == 'rumble') {
      player = <RumbleVideo src={this.state.src} autoplay={autoplay}/>;
    } else {
      const fileDetails = this.props.section.prop('file_details') || {};
      player = (
        <Player
          aspectRatio={this.state.aspect_ratio}
          src={this.state.src}
          thumbnailSrc={this.state.thumbnailSrc}
          height="100%"
          responsive={this.props.section.prop('height') === 0}
          streamingMp3={fileDetails.streaming_mp3}
          loopVideo={fileDetails.loop_video}
          hideControls={fileDetails.hide_controls}
          autoplay={autoplay}
          scrollPlay={this.props.section.prop('scroll_play')}
          onReady={this.hideLoad}
        />
      );
    }
    let publisher;
    if (
      details.type === 'live' &&
      FW.store.get('user') &&
      FW.store.get('user').may('publish_live_stream_channel', this.channel) &&
      (this.channel.get('publish_method') === 0 || this.channel.get('publish_method') === 2)
    ) {
      publisher = (
        <div
          className="col-md-12"
          style={{
            textAlign: 'center',
            position: 'absolute',
            top: 10,
            height: 30,
            float: 'left',
            zIndex: 1
          }}
        >
          <span
            onClick={this.openPublisher.bind(this)}
            className="btn btn-primary"
          >
            Start Publishing
          </span>
        </div>
      );
    }

    const aspectRatios = {
      '16:9': '56.25%',
      '14:5': '35.71%',
      '4:3': '75%',
      '3:2': '66.66%',
      '1:1': '100%'
    };
    const height = this.props.section.prop('height');
    const padding = !height ? aspectRatios[this.state.aspect_ratio || '16:9'] : null;

    return this.state.src ? (
      <div className="video-section" style={{position: 'relative', width: '100%', paddingTop: padding, height: height}}>
        <div style={{position: 'absolute', top: 0, left: 0, bottom: 0, right: 0}}>
          {publisher}
          {!this.state.loaded && autoplay && details.type !== 'vimeo' ? <div style={{
            position: 'absolute',
            display: 'flex',
            top: 0, left: 0, right: 0, bottom: 0,
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <Loading wheel />
          </div> : null}
          {player}
        </div>
      </div>
    ) : null;
  }
}

export default Video;
